import { Typography } from "@mui/material"
import Stack from "@mui/material/Stack"
import { useEffect, useState } from "react";

interface ChartProps {
    value1: number
    value2: number
    label1: string
    label2: string
}

const Chart: React.FC<ChartProps> = ({value1, value2, label1, label2}) => {

    const [toggle, setToggle] = useState(false)
    const [length, setLength] = useState<number | null>(null)
    //console.log(strokeDashOffset.to((x) => console.log(x)))

    /*useEffect(() => {
        setImmediate(() => {
            setLength(value1)
            setToggle(true)
        })
    }, [])*/

    const chartRadius = 200
    const chartCircumference = Math.PI * 2 * chartRadius
    console.debug("Chart circumference is: ", chartCircumference)
  
    const margin = chartCircumference / 360 * 5
  
    const totalValue = value1 + value2
    const x = value1 / totalValue * 100
    const y = value2 / totalValue * 100
  
    const offsetX = (chartCircumference / 100 * x) + (margin * 2)
    const offsetY = (chartCircumference / 100 * y) + (margin * 2)
    console.debug(`OffsetX: ${offsetX}. OffsetY: ${offsetY}`)
  
    return (
      <div style={{width: "250px", height: "250px", position: "relative", margin: "0 auto"}}>
        <svg viewBox="0 0 450 450" style={{transform: "scale(-1, 1) rotate(275deg)", position: "absolute"}}>
          <circle
            stroke="#a5cbe0"
            fill="none"
            strokeWidth={20} 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeMiterlimit={10}
            strokeDasharray={chartCircumference}
            strokeDashoffset={offsetX}
            cx="50%" 
            cy="50%" 
            r={chartRadius}
          />
        </svg>
        <svg viewBox="0 0 450 450" style={{transform: "rotate(-85deg)", position: "absolute"}}>
          <circle
            stroke="#005aa4"
            fill="none"
            strokeWidth={20} 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeMiterlimit={10} 
            strokeDasharray={chartCircumference}
            strokeDashoffset={offsetY}
            cx="50%" 
            cy="50%" 
            r={chartRadius}
          />
        </svg>
        <div style={{position: "absolute", top: "90px",  width: "150px", left: "50px"}}>
          <Stack>
              <Typography variant="h6">Tilgjengelig limit:</Typography>
              <Typography variant="h5">{label1}</Typography>
          </Stack>
        </div>
      </div>
    )
  }

  /*

            <Stack direction="row" justifyContent="space-around">
              <div style={{width: "200px"}}>
                <p style={{textAlign: "center"}} >{label1}</p>
              </div>
              <div style={{width: "200px", borderLeft: "1px #333 solid"}}>
                <p style={{textAlign: "center"}} >{label2}</p>
              </div>
            </Stack>
*/
  export default Chart